import { Controller } from "@hotwired/stimulus"
import Inputmask from 'inputmask'

// Connects to data-controller="mask-currency"
export default class extends Controller {
  connect() {
    Inputmask({ alias: 'currency', radixPoint: ',' }).mask(this.element)
  }
}
